module.exports = __webpack_public_path__ + "img/health_good.7b2be276.svg";